module.exports = __webpack_public_path__ + "static/media/prism-2.202e6ed9.mp3";